/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { Navigate, Route, Routes } from "react-router-dom";
import UserRoute from "./UserRoute";
import MainLayout from "../Layout/MainLayout";
import AdminLayout from "../Layout/AdminLayout";
import LoginPage from "../Pages/LoginPage";
import SignInPage from "../Pages/SignInPage";
import CategoryManagement from "../Pages/admin/CategoryManagement";
import UserManagement from "../Pages/admin/UserManagement";
import RoleManagement from "../Pages/admin/RoleManagement";
import PrivilegeManagement from "../Pages/admin/PrivilageManagement";
import MappingManagement from "../Pages/admin/MappingManagement";
import HomePage from "../Pages/HomePage";
import ForgotPassword from "../Pages/ForgotPassword";
import ResetPassword from "../Pages/ResetPassword";
import CheckoutPage from "../Pages/CheckoutPage";
import RestaurantPage from "../Pages/RestaurantPage";
import KitchenPage from "../Pages/KitchenPage";
import ServerPage from "../Pages/ServerPage";
import BillingPage from "../Pages/BillingPage";
import OrderPage from "../Pages/OrderPage";
import DashboardPage from "../Pages/DashboardPage";
import DeliveryOrdersPage from "../Pages/DeliveryOrdersPage";

const PageRoutes = ({ themeMode, onThemeToggle }) => (
    <Routes>
        <Route path="/login" element={<SignInPage themeMode={themeMode} onThemeToggle={onThemeToggle} />} />
        <Route path="/pos" element={<LoginPage themeMode={themeMode} onThemeToggle={onThemeToggle} />} />
        <Route path="/landing" element={<Navigate to="/pos" replace />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token/:email" element={<ResetPassword />} />
        {/* <Route index element={<HomePage />} /> */}

        <Route path="/" element={
            <UserRoute>
                <MainLayout themeMode={themeMode} onThemeToggle={onThemeToggle} />
            </UserRoute>
        }>
            <Route index element={<DashboardPage />} />
            <Route path="supermarket" element={<HomePage />} />
            <Route path="restaurant" element={<RestaurantPage />} />
            <Route path="kitchen" element={<KitchenPage />} />
            <Route path="server" element={<ServerPage />} />
            <Route path="delivery" element={<DeliveryOrdersPage />} />
            <Route path="billing" element={<BillingPage />} />
            <Route path="order" element={<OrderPage />} />
            <Route path="user" element={<UserManagement />} />
            <Route path="checkout" element={<CheckoutPage />} />

        </Route>

        <Route path="/admin" element={
            <UserRoute>
                <AdminLayout themeMode={themeMode} onThemeToggle={onThemeToggle} />
            </UserRoute>
        }>
            <Route path="user" element={<UserManagement />} />
            <Route path="category" element={<CategoryManagement />} />
            <Route path="role" element={<RoleManagement />} />
            <Route path="privilege" element={<PrivilegeManagement />} />
            <Route path="br-priv-mapping" element={<MappingManagement />} />



        </Route>
    </Routes>
);

export default PageRoutes;